// import React, { useState, useMemo, useEffect, useRef } from "react";
// import moment from "moment";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// export default function LeaveApprovalTable({
//   leaveRequests,
//   onTakeAction,
//   feedbackMsg,
//   showModal,
//   LeaveDecisionModal,
//   selectedRequest,
//   onCloseModal,
//   onSubmitDecision,
//   userRole, // <-- Added userRole prop
//   token, // <-- Added token prop
// }) {
//   // Search state
//   const [search, setSearch] = useState("");

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;

//   // Export dropdown open/close state
//   const [exportDropdownOpen, setExportDropdownOpen] = useState(false);
//   const dropdownRef = useRef(null);

//   // Filter leaveRequests by search query (name, leave type, status)
//   const filteredLeaves = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return leaveRequests;

//     return leaveRequests.filter((lr) => {
//       const fullName = `${lr.firstName} ${lr.lastName}`.toLowerCase();
//       return (
//         fullName.includes(q) ||
//         (lr.typeOfLeave && lr.typeOfLeave.toLowerCase().includes(q)) ||
//         (lr.status && lr.status.toLowerCase().includes(q))
//       );
//     });
//   }, [leaveRequests, search]);

//   // Reset to page 1 if filtered data changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, leaveRequests]);

//   // Paginated data slice
//   const paginatedLeaves = useMemo(() => {
//     const start = (currentPage - 1) * itemsPerPage;
//     return filteredLeaves.slice(start, start + itemsPerPage);
//   }, [filteredLeaves, currentPage]);

//   // Calculate total pages
//   const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

//   // Map leave request data for export, includes Department and Job Title
//   const mapLeaveToExportRow = (lr) => ({
//     "Employee Name": `${lr.firstName} ${lr.lastName}`,
//     Department: lr.department || "",
//     "Job Title": lr.position || "",
//     "Leave Type": lr.typeOfLeave || "",
//     "Start Date": moment(lr.startDate).format("YYYY-MM-DD"),
//     "End Date": moment(lr.endDate).format("YYYY-MM-DD"),
//     Duration: `${lr.numberRequested} ${lr.hoursOrDays || ""}`,
//     Status: lr.status || "",
//   });

//   // Export Excel
//   const exportToExcel = () => {
//     if (!filteredLeaves.length) {
//       alert("No leave requests to export!");
//       return;
//     }
//     const exportData = filteredLeaves.map(mapLeaveToExportRow);

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Requests");

//     // Auto adjust column widths
//     const maxColWidths = Object.keys(exportData[0]).map((col) => {
//       const maxLength = Math.max(
//         col.length,
//         ...exportData.map((row) => (row[col] ? row[col].toString().length : 0))
//       );
//       return { wch: maxLength + 5 };
//     });
//     worksheet["!cols"] = maxColWidths;

//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const dataBlob = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     });
//     saveAs(dataBlob, "leave_requests_export.xlsx");
//   };

//   // Export CSV
//   const exportToCSV = () => {
//     if (!filteredLeaves.length) {
//       alert("No leave requests to export!");
//       return;
//     }
//     const exportData = filteredLeaves.map(mapLeaveToExportRow);
//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const csv = XLSX.utils.sheet_to_csv(worksheet);

//     const csvBlob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//     saveAs(csvBlob, "leave_requests_export.csv");
//   };

//   // Export PDF
//   const exportToPDF = () => {
//     if (!filteredLeaves.length) {
//       alert("No leave requests to export!");
//       return;
//     }

//     const exportData = filteredLeaves.map(mapLeaveToExportRow);
//     const doc = new jsPDF("l", "pt", "a4");

//     const columns = Object.keys(exportData[0]);

//     doc.setFontSize(18);
//     doc.setTextColor(237, 125, 49);
//     doc.text("Leave Requests Export", 40, 40);

//     autoTable(doc, {
//       startY: 60,
//       head: [columns],
//       body: exportData.map((row) => columns.map((col) => row[col])),
//       styles: { fontSize: 9, cellPadding: 4 },
//       headStyles: { fillColor: [237, 125, 49] },
//       theme: "striped",
//       margin: { left: 20, right: 20 },
//       didDrawPage: (data) => {
//         const pageCount = doc.internal.getNumberOfPages();
//         doc.setFontSize(10);
//         doc.setTextColor(150);
//         doc.text(
//           `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
//           data.settings.margin.left,
//           doc.internal.pageSize.height - 10
//         );
//       },
//     });

//     doc.save("leave_requests_export.pdf");
//   };

//   // Export button handler
//   const handleExport = (format) => {
//     setExportDropdownOpen(false);
//     switch (format) {
//       case "excel":
//         exportToExcel();
//         break;
//       case "csv":
//         exportToCSV();
//         break;
//       case "pdf":
//         exportToPDF();
//         break;
//       default:
//         alert("Unsupported export format");
//     }
//   };

//   // Close dropdown on outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setExportDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Determine if the "Take Action" button should be visible for a request
//   const canTakeAction = (request) => {
//     // If the user is an HR Officer, they can act on a 'Pending' request.
//     if (userRole === 'hr_officer' && request.status === 'Pending') {
//       return true;
//     }
//     // If the user is a Program Director, they can act on an 'HR_Recommended' request.
//     if (userRole === 'program_director' && request.status === 'HR_Recommended') {
//       return true;
//     }
//     return false;
//   };

//   return (
//     <div className="mt-8 bg-white rounded shadow p-4">
//       <h2 className="text-lg font-semibold text-gray-700 mb-4">Leave Approval Table</h2>

//       {/* Search and Export controls */}
//       <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
//         {/* Search input */}
//         <input
//           type="search"
//           placeholder="Search leave requests by employee, type or status"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="w-full sm:max-w-xs rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
//           aria-label="Search leave requests"
//         />

//         {/* Export dropdown */}
//         <div className="relative inline-block text-left" ref={dropdownRef}>
//           <button
//             onClick={() => setExportDropdownOpen((open) => !open)}
//             type="button"
//             className="inline-flex justify-center w-full rounded bg-orange-600 px-4 py-2 text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
//             aria-haspopup="true"
//             aria-expanded={exportDropdownOpen}
//             aria-controls="export-menu"
//           >
//             Export
//             <svg
//               className="ml-2 -mr-1 h-5 w-5"
//               xmlns="http://www.w3.org/2000/svg"
//               viewBox="0 0 20 20"
//               fill="currentColor"
//               aria-hidden="true"
//             >
//               <path
//                 fillRule="evenodd"
//                 d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z"
//                 clipRule="evenodd"
//               />
//             </svg>
//           </button>

//           {/* Dropdown menu */}
//           {exportDropdownOpen && (
//             <div
//               id="export-menu"
//               className="origin-top-right absolute right-0 mt-2 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
//               role="menu"
//               aria-orientation="vertical"
//               aria-labelledby="export-menu-button"
//               tabIndex={-1}
//             >
//               <div className="py-1">
//                 {["excel", "csv", "pdf"].map((format) => (
//                   <button
//                     key={format}
//                     onClick={() => handleExport(format)}
//                     className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-orange-100 hover:text-orange-900"
//                     role="menuitem"
//                   >
//                     Export as {format.toUpperCase()}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="min-w-full text-sm">
//           <thead>
//             <tr className="bg-orange-100 text-gray-600 text-left">
//               <th className="px-4 text-orange-600 py-2">Employee Name</th>
//               <th className="px-4 text-orange-600 py-2">Leave Type</th>
//               <th className="px-4 text-orange-600 py-2">Date Range</th>
//               <th className="px-4 text-orange-600 py-2">Duration</th>
//               <th className="px-4 text-orange-600 py-2">Status</th>
//               <th className="px-4 text-orange-600 py-2">Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedLeaves.length === 0 ? (
//               <tr>
//                 <td colSpan="6" className="text-center text-gray-500 py-4">
//                   No leave requests found.
//                 </td>
//               </tr>
//             ) : (
//               paginatedLeaves.map((request, idx) => (
//                 <tr key={request._id || idx} className="border-b">
//                   <td className="px-4 py-2">
//                     {request.firstName} {request.lastName}
//                   </td>
//                   <td className="px-4 py-2">{request.typeOfLeave}</td>
//                   <td className="px-4 py-2">
//                     {moment(request.startDate).format("MMM D")} –{" "}
//                     {moment(request.endDate).format("MMM D")}
//                   </td>
//                   <td className="px-4 py-2">
//                     {request.numberRequested} {request.hoursOrDays?.toLowerCase()}
//                   </td>
//                   <td className="px-4 py-2 capitalize">
//                     <span
//                       className={`font-semibold ${request.status === "Program_Director_Approved"
//                         ? "text-green-600"
//                         : request.status === "Rejected" || request.status === "Cancelled"
//                           ? "text-red-600"
//                           : "text-orange-600"
//                         }`}
//                     >
//                       {request.status.replace(/_/g, " ")}
//                     </span>
//                   </td>
//                   <td className="px-4 py-2">
//                     {canTakeAction(request) ? (
//                       <button
//                         onClick={() => onTakeAction(request)}
//                         className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600"
//                       >
//                         Take Action
//                       </button>
//                     ) : (
//                       <span className="text-gray-400 italic">Action taken</span>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Controls */}
//       {totalPages > 1 && (
//         <div className="mt-4 flex justify-center gap-2">
//           <button
//             onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//             disabled={currentPage === 1}
//             className={`rounded px-3 py-1 ${currentPage === 1
//               ? "cursor-not-allowed bg-gray-300"
//               : "bg-orange-100 text-orange-600 hover:bg-orange-200"
//               }`}
//           >
//             Prev
//           </button>

//           {[...Array(totalPages)].map((_, i) => (
//             <button
//               key={i}
//               onClick={() => setCurrentPage(i + 1)}
//               className={`rounded px-3 py-1 ${currentPage === i + 1
//                 ? "bg-orange-300 text-orange-900 font-semibold"
//                 : "bg-gray-200 hover:bg-gray-300"
//                 }`}
//             >
//               {i + 1}
//             </button>
//           ))}

//           <button
//             onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
//             disabled={currentPage === totalPages}
//             className={`rounded px-3 py-1 ${currentPage === totalPages
//               ? "cursor-not-allowed bg-gray-300"
//               : "bg-orange-100 text-orange-600 hover:bg-orange-200"
//               }`}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Modal */}
//       {LeaveDecisionModal && (
//         <LeaveDecisionModal
//           isOpen={showModal}
//           onClose={onCloseModal}
//           onSubmit={onSubmitDecision}
//           leaveRequest={selectedRequest}
//           token={token}
//           userRole={userRole}
//         />
//       )}

//       {/* Feedback */}
//       {feedbackMsg && (
//         <div className="mt-4 text-sm text-center text-green-600">{feedbackMsg}</div>
//       )}
//     </div>
//   );
// }
import React, { useState, useMemo, useEffect, useRef } from "react";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function LeaveApprovalTable({
  leaveRequests,
  onTakeAction,
  feedbackMsg,
  showModal,
  LeaveDecisionModal,
  selectedRequest,
  onCloseModal,
  onSubmitDecision,
  userRole,
  token,
}) {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [exportDropdownOpen, setExportDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const filteredLeaves = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return leaveRequests;
    return leaveRequests.filter((lr) => {
      const fullName = `${lr.firstName} ${lr.lastName}`.toLowerCase();
      return (
        fullName.includes(q) ||
        (lr.typeOfLeave && lr.typeOfLeave.toLowerCase().includes(q)) ||
        (lr.status && lr.status.toLowerCase().includes(q))
      );
    });
  }, [leaveRequests, search]);

  useEffect(() => setCurrentPage(1), [search, leaveRequests]);

  const paginatedLeaves = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredLeaves.slice(start, start + itemsPerPage);
  }, [filteredLeaves, currentPage]);

  const totalPages = Math.ceil(filteredLeaves.length / itemsPerPage);

  const mapLeaveToExportRow = (lr) => ({
    "Employee Name": `${lr.firstName} ${lr.lastName}`,
    Department: lr.department || "",
    "Job Title": lr.position || "",
    "Leave Type": lr.typeOfLeave || "",
    "Start Date": moment(lr.startDate).format("YYYY-MM-DD"),
    "End Date": moment(lr.endDate).format("YYYY-MM-DD"),
    Duration: `${lr.numberRequested} ${lr.hoursOrDays || ""}`,
    Status: lr.status || "",
  });

  const exportToExcel = () => {
    if (!filteredLeaves.length) return alert("No leave requests to export!");
    const exportData = filteredLeaves.map(mapLeaveToExportRow);
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Requests");
    worksheet["!cols"] = Object.keys(exportData[0]).map((col) => ({
      wch: Math.max(
        col.length,
        ...exportData.map((row) => (row[col] ? row[col].toString().length : 0))
      ) + 5,
    }));
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "leave_requests_export.xlsx");
  };

  const exportToCSV = () => {
    if (!filteredLeaves.length) return alert("No leave requests to export!");
    const worksheet = XLSX.utils.json_to_sheet(filteredLeaves.map(mapLeaveToExportRow));
    const csv = XLSX.utils.sheet_to_csv(worksheet);
    saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), "leave_requests_export.csv");
  };

  const exportToPDF = () => {
    if (!filteredLeaves.length) return alert("No leave requests to export!");
    const exportData = filteredLeaves.map(mapLeaveToExportRow);
    const doc = new jsPDF("l", "pt", "a4");
    const columns = Object.keys(exportData[0]);
    doc.setFontSize(18);
    doc.setTextColor(237, 125, 49);
    doc.text("Leave Requests Export", 40, 40);
    autoTable(doc, {
      startY: 60,
      head: [columns],
      body: exportData.map((row) => columns.map((col) => row[col])),
      styles: { fontSize: 9, cellPadding: 4 },
      headStyles: { fillColor: [237, 125, 49] },
      theme: "striped",
      margin: { left: 20, right: 20 },
      didDrawPage: (data) => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.setTextColor(150);
        doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, doc.internal.pageSize.height - 10);
      },
    });
    doc.save("leave_requests_export.pdf");
  };

  const handleExport = (format) => {
    setExportDropdownOpen(false);
    switch (format) {
      case "excel": return exportToExcel();
      case "csv": return exportToCSV();
      case "pdf": return exportToPDF();
      default: alert("Unsupported export format");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setExportDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const canTakeAction = (request) => {
    if (userRole === 'hr_officer' && request.status === 'Pending') return true;
    if (userRole === 'program_director' && request.status === 'HR_Recommended') return true;
    return false;
  };

  return (
    <div className="mt-8 bg-white rounded shadow p-4">
      <h2 className="text-lg font-semibold text-gray-700 mb-4">Leave Approval Table</h2>

      {/* Search and Export */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
        <input
          type="search"
          placeholder="Search leave requests by employee, type or status"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full sm:max-w-xs rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
        />
        <div className="relative inline-block text-left" ref={dropdownRef}>
          <button
            onClick={() => setExportDropdownOpen(!exportDropdownOpen)}
            className="inline-flex justify-center w-full rounded bg-orange-600 px-4 py-2 text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500"
          >
            Export
            <svg className="ml-2 -mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
            </svg>
          </button>
          {exportDropdownOpen && (
            <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-50">
              <div className="py-1">
                {["excel", "csv", "pdf"].map((format) => (
                  <button
                    key={format}
                    onClick={() => handleExport(format)}
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-orange-100 hover:text-orange-900"
                  >
                    Export as {format.toUpperCase()}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-orange-100 text-gray-600 text-left">
              <th className="px-4 py-2">Employee Name</th>
              <th className="px-4 py-2">Leave Type</th>
              <th className="px-4 py-2">Date Range</th>
              <th className="px-4 py-2">Duration</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedLeaves.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center text-gray-500 py-4">No leave requests found.</td>
              </tr>
            ) : paginatedLeaves.map((request, idx) => (
              <tr key={request._id || idx} className="border-b">
                <td className="px-4 py-2">{request.firstName} {request.lastName}</td>
                <td className="px-4 py-2">{request.typeOfLeave}</td>
                <td className="px-4 py-2">{moment(request.startDate).format("MMM D")} – {moment(request.endDate).format("MMM D")}</td>
                <td className="px-4 py-2">{request.numberRequested} {request.hoursOrDays?.toLowerCase()}</td>
                <td className="px-4 py-2 capitalize">
                  <span className={`${request.status.includes('Approved') ? 'text-green-600' : request.status === 'Rejected' ? 'text-red-600' : 'text-orange-600'} font-semibold`}>
                    {request.status.replace(/_/g, " ")}
                  </span>
                </td>
                <td className="px-4 py-2">
                  {canTakeAction(request) ? (
                    <button onClick={() => onTakeAction(request)} className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600">Take Action</button>
                  ) : <span className="text-gray-400 italic">Action taken</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card Layout */}
      <div className="md:hidden space-y-4">
        {paginatedLeaves.length === 0 ? (
          <p className="text-center text-gray-500">No leave requests found.</p>
        ) : paginatedLeaves.map((request, idx) => (
          <div key={request._id || idx} className="border rounded-lg p-4 shadow-sm bg-white">
            <div className="flex justify-between items-center mb-2">
              <span className="font-semibold">{request.firstName} {request.lastName}</span>
              <span className={`capitalize font-semibold ${request.status.includes('Approved') ? 'text-green-600' : request.status === 'Rejected' ? 'text-red-600' : 'text-orange-600'}`}>
                {request.status.replace(/_/g, " ")}
              </span>
            </div>
            <p className="text-sm text-gray-600"><strong>Leave Type:</strong> {request.typeOfLeave}</p>
            <p className="text-sm text-gray-600"><strong>Date:</strong> {moment(request.startDate).format("MMM D")} – {moment(request.endDate).format("MMM D")}</p>
            <p className="text-sm text-gray-600"><strong>Duration:</strong> {request.numberRequested} {request.hoursOrDays?.toLowerCase()}</p>
            <div className="mt-2">
              {canTakeAction(request) ? (
                <button onClick={() => onTakeAction(request)} className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600">Take Action</button>
              ) : <span className="text-gray-400 italic">Action taken</span>}
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="mt-4 flex justify-center gap-2 flex-wrap">
          <button onClick={() => setCurrentPage(p => Math.max(1, p-1))} disabled={currentPage===1} className={`rounded px-3 py-1 ${currentPage===1?'bg-gray-300 cursor-not-allowed':'bg-orange-100 hover:bg-orange-200'}`}>Prev</button>
          {[...Array(totalPages)].map((_, i) => (
            <button key={i} onClick={() => setCurrentPage(i+1)} className={`rounded px-3 py-1 ${currentPage===i+1?'bg-orange-300 font-semibold':'bg-gray-200 hover:bg-gray-300'}`}>{i+1}</button>
          ))}
          <button onClick={() => setCurrentPage(p => Math.min(totalPages, p+1))} disabled={currentPage===totalPages} className={`rounded px-3 py-1 ${currentPage===totalPages?'bg-gray-300 cursor-not-allowed':'bg-orange-100 hover:bg-orange-200'}`}>Next</button>
        </div>
      )}

      {LeaveDecisionModal && <LeaveDecisionModal isOpen={showModal} onClose={onCloseModal} onSubmit={onSubmitDecision} leaveRequest={selectedRequest} token={token} userRole={userRole} />}
      {feedbackMsg && <div className="mt-4 text-sm text-center text-green-600">{feedbackMsg}</div>}
    </div>
  );
}
